import React from 'react';
import styled from 'styled-components';

import { ReactComponent as QuestionSvg } from '../../../../_assets/svg/question.svg';

const Container = styled.div`
  margin-right: 9px;
  height: 36px;
  width: 36px;
  min-width: 36px;
`;

const ConfirmIcon = () => {
  return (
    <Container>
      <QuestionSvg></QuestionSvg>
    </Container>
  );
};

export default ConfirmIcon;
